export class Flag {
	public id: number
	public name: string
	public key: string

	constructor(data: { id: number; name: string; key: string }) {
		this.id = data.id
		this.name = data.name
		this.key = data.key
	}

	static create(partial: Partial<Flag>): Flag {
		const defaults = {
			id: 0,
			name: '',
			key: '',
		}
		return new Flag({ ...defaults, ...partial })
	}
}
